
import { Vue, Component, Prop } from "vue-property-decorator";

import ModalContent from "@/components/modal/ModalContent.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import UiButton from "@/components/button/ui-button.vue";
import ScheduleInfoIcon from '@/components/icons/ScheduleInfoIcon.vue'
@Component({
  components: {
    ModalContent,
    UiButton,
    ModalFullScreen,
	ScheduleInfoIcon
  },
})
export default class AlertModel extends Vue {
  @Prop({ type: String, required: true }) title!: String;
  @Prop({ type: String, required: false }) text: number;
  @Prop({ type: String, required: false, default: "OK" }) okBtnText: String;
  @Prop({ type: String, required: false, default: "" }) descriptionClasses?: String;
    @Prop({ type: String, default: 'xs' }) readonly size: string;
  @Prop({ type: String, required: false, default: "Cancel" })
  noBtnText: String;
  @Prop({type: Boolean, default: false}) hasIcon?: boolean;
  @Prop({
    type: Object,
    required: false,
    default: { okBtn: true, noBtn: true },
  })
  actions?: { okBtn: boolean; noBtn: boolean };

  closeModal(value: boolean): void {
    this.$emit("input", value);
    this.$emit("closeModel");
  }
}
